<template>
  <div v-on-click-away="hideMenu" class="variables-menu">
    <div class="variables-menu__button" :class="{ active: isShowMenu }" @click="action">
      {{ !currentVariable ? '+' : '-' }}
    </div>

    <transition name="slide-fade">
      <div v-if="isShowMenu" class="variables-menu__menu">
        <div
          v-for="item in questionVariables"
          :key="item.name"
          class="variables-menu__menu-item"
          @click="sendVariable(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { directive as VueClickAway } from 'vue-clickaway';

export default {
  name: 'QuestionVariablesMenu',

  directives: {
    onClickAway: VueClickAway
  },

  props: {
    questionVariables: {
      type: Array,
      default: () => []
    },

    currentVariable: {
      type: [String, Boolean],
      default: false
    }
  },

  data() {
    return {
      isShowMenu: false
    };
  },

  methods: {
    sendVariable(variableName) {
      this.$emit('click', variableName);
      this.isShowMenu = false;
    },

    action() {
      if (!this.currentVariable) {
        this.isShowMenu = !this.isShowMenu;
      } else {
        this.$emit('remove', this.currentVariable);
      }
    },

    hideMenu() {
      this.isShowMenu = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.variables-menu {
  width: 1.6rem;
  position: relative;

  &__button {
    width: 1.6rem;
    height: 1.6rem;
    color: $grey-darker;
    border: none;
    background-color: transparent;
    border-radius: 4px;
    padding: 5px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.active {
      background: $grey-light;
    }

    &:hover {
      color: #fff;
      background-color: $green;
      transition: all 0.3s;
    }
  }

  &__menu {
    padding: 10px 0;
    min-width: 100px;
    width: auto;
    max-width: 200px;
    max-height: 200px;
    overflow-y: auto;
    background: $white;
    box-shadow: $box-shadow;
    position: absolute;
    top: 27px;
    right: 0;
    border: 1px solid $grey-light;
    z-index: 9999;
  }

  &__menu-item {
    @include mixin-text-main;
    white-space: nowrap;
    padding: 4px 10px;
    cursor: pointer;
    transition: background 0.3s, color 0.3s;

    &:hover {
      background: $green;
      color: $white;
      transition: background 0.3s, color 0.3s;
    }
  }
}
</style>
